module.exports = __webpack_public_path__ + "static/img/checkmark--filled.48f1f1b5.svg";